import bookingListComponent from './booking-list.component';

const bookingListModule = angular
  .module('bookingList', [])
  .component('bookingList', bookingListComponent);

export default bookingListModule;



/** WEBPACK FOOTER **
 ** ./frontend/components/booking/booking-list/booking-list.js
 **/